import './stringray.css';
import React, {Component} from "react";
import { connect } from 'react-redux';

import Resume from '../../components/Resume';
import MusicStations from './stringrayStations';
import Spinner from './../../components/Spinner';
import MusicUtils from "../../actions/musica/music-actions";
import MusicActions from '../../components/MusicActions';
import { fetchLoginDynamic } from '../../reducers/user';
import { setResumeData } from "../../actions/resume";
import { getCurrentImage, getCurrentAlbumName, getCurrentTitle } from '../../actions/musica/player-action-creators';
import { doPGMRadio } from '../../actions/musica/player-shared-action-creators';
import { playFullMedia } from '../../actions/playmedia';

class Radios extends Component {
  constructor(props) {
    super(props);
    this.onFocusCardHandler = this.onFocusCardHandler.bind(this);
    this.setIsFetching = this.setIsFetching.bind(this);
    this.state = {
      purchaseButtonInfo: null,
      user: props.user,
      itemData: {},
      isFetching: false,
      talkRadios: [],
      genreRadios: [],
      artistsRadios: [],
      selectedRadio: {},
      pgm: null
    };
    this.handlePlay = this.handlePlay.bind(this);
  }

  onFocusCardHandler(data, index) {
    if (this.idTimeout) {
      clearTimeout(this.idTimeout);
    }
    this.idTimeout = setTimeout(() => {
      const elements = document.getElementsByClassName('focused');
      if(elements.length > 0)
        elements[0].classList.remove('focused');

      const selEl= document.getElementById(`card-${data.id}`);
      console.log(data);
      if(selEl){
        selEl.classList.add("focused");
      }

      const itemData = {
        title: data.name || data.artist,
        year: data.band,
        rating: data.rating_code,
        category: data.dial !== undefined ? `Radio ${data.dial}` : '',
        duration: data.totalTime,
        description: data.total_time,
        previewImage: getCurrentImage(this.props.playerMusica),
        titleSong: getCurrentTitle(this.props.playerMusica),
        album: getCurrentAlbumName(this.props.playerMusica),
        href: `/player/${this.props.playerMusica.currentContent? this.props.playerMusica.currentContent.id : ''}`,
        isMusic: true,
        pgm: MusicUtils.getPgmFromState(this.props.playerMusica.currentContent, this.props.playerMusica.contentType)
      };
      this.setState({
        selectedRadio: data
      });
        this.props.setResumeData(itemData);
    },500);
  }

  setIsFetching(isFetching){
    this.setState({isFetching})
  }

  shouldComponentUpdate(nextProps,nextState) {
    return this.state.itemData !== nextState.itemData ||
      this.props.user !== nextProps.user ||
      this.state.isFetching !== nextState.isFetching ||
      this.state.pgm !== nextState.pgm;
  }

  componentWillMount() {
    if(this.props.user.musicUser === undefined){
      this.props.fetchLoginDynamic(this.state.user.email);
      this.setState({user: this.props.user.musicUser});
    }
  }

  handlePlay(){
    const pgm = this.props.onPlayRadio(this.state.selectedRadio.url, this.state.selectedRadio);
    if(pgm) {
      this.props.playFullMedia({
        playerstate: 'PLAYING',
        source: {
          audiosource: pgm.media.video_url,
        },
        ispreview: false,
        islive: false,
        ispip: false,
      });
    }
  }

  render() {
    return (
      <div className="radios-container">
        { this.state.isFetching? <Spinner className="spinner-music"/> : ''}
        <Resume {...this.state.itemData} />
        {this.props.user.musicUser ?
              <MusicStations
                onFocusCardHandler={this.onFocusCardHandler}
                setIsFetching={this.setIsFetching}
                service="Radios"
                user={this.props.user}
                ref={instance => { this.musicStations = instance; }}
              />
            : ''}
        <MusicActions
          actionType="radios"
          buttonData={this.state.selectedRadio}
          blueAction={this.handlePlay}
          isHidden={true}
          device={MusicUtils.getMusicDevice()}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({ user: state.user, playerMusica: state.playermusica });
const mapDispatchToProps = dispatch => ({
  fetchLoginDynamic: (email) => dispatch(fetchLoginDynamic(email)),
  setResumeData: (itemData) => dispatch(setResumeData(itemData)),
  onPlayRadio: (index,state) => dispatch(doPGMRadio(index, state)),
  playFullMedia: (pgm) => dispatch(playFullMedia(pgm))
});
export default connect(mapStateToProps, mapDispatchToProps)(Radios);



// WEBPACK FOOTER //
// ./src/containers/Stringray/index.jsx